import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const QrRedirect = () => {
  const navigate = useNavigate();

  let os = 'desktop'
  const isMobile = {
    huawei() {
      return /huawei/i.test(navigator.userAgent)
    },
    android() {
      return /Android/i.test(navigator.userAgent)
    },
    iOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent)
    },
  }

  useEffect(() => {
    if (isMobile.huawei()) os = 'huawei'
    else if (isMobile.android()) os = 'android'
    else if (isMobile.iOS()) os = 'ios'

    function redirect() {
      if (isMobile.huawei())
        document.location.href = 'https://appgallery.huawei.com/app/C104770227'
      else if (isMobile.android())
        document.location.href =
          'https://play.google.com/store/apps/details?id=my.com.alrajhibank.wick'
      else if (isMobile.iOS())
        document.location.href = 'https://apps.apple.com/app/rize-my/id1587293861'
      else navigate("/", { replace: true });
    }

    redirect();

  }, []);

  return (
    <div className="container">Redirecting...</div>
  )
}

export default QrRedirect
